import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCurrentUser } from 'containers/App/selectors';
import moment from 'moment';

const styles = (theme) => ({
  root: {
    color: theme.palette.text.primary,
  },
});

class PatientJourneyCardSubheader extends Component {
  render() {
    const { classes, event, currentUser } = this.props;
    if (!event || !event.date) {
      return <span />;
    }
    let date = event.date;
    if (event.details && event.details.date) {
      date = moment(event.details.date);
    }
    if (/referrals|insurances/.test(event.type)) {
      date = moment(event.details.createdAt);
    }
    if (/billingTransactions|patientForms/.test(event.type)) {
      date = moment(event.details.updatedAt);
    }
    const pattern = /diagnoses|procedures|feedback/.test(event.type) ? 'LL' : 'LLL';
    return <span className={classes.root}>{date.tz(currentUser.settings.timezone).format(pattern)}</span>;
  }
}

PatientJourneyCardSubheader.propTypes = {
  classes: PropTypes.object.isRequired,
  event: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = createStructuredSelector({
  currentUser: makeSelectCurrentUser(),
});

export default compose(connect(mapStateToProps, null), withStyles(styles))(PatientJourneyCardSubheader);
